/**
 * UserActionsSheet
 *
 * Helper function to show user actions sheet using SheetService.
 * Matches Flutter implementation: lib/presentation/bottom_sheet/user_actions_bottom_sheet.dart
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { UserActionsContent } from './components/UserActionsContent';
import type { UserEntity } from '@/domain/entities/user/userEntity';

/**
 * Show user actions sheet
 *
 * @param user - Optional UserEntity if already fetched
 * @param userId - Optional user ID if user needs to be fetched
 * @param container - Optional container element, screen key string, or null
 * @param screenKey - Optional screen key of the route opening this sheet
 * @param fixedHeight - Fixed height for the sheet, from responsive.userActionsSheet.fixedHeight
 * @param includeAccountActions - When `true`, the current-user list includes the owner
 *   account-management items (Edit profile, Settings, Help & About, Log out, Delete account).
 *   Passed `true` only from the `UserDetailsPage` app-bar entry.
 */
const show = (
  user?: UserEntity,
  userId?: string,
  container?: HTMLElement | string | null,
  screenKey?: string,
  fixedHeight?: string,
  includeAccountActions?: boolean,
) => {
  // Determine the title - use user.name if available, otherwise empty string (will be set when user loads)
  const title = user?.name || '';

  SheetService.show({
    title,
    content: (
      <UserActionsContent
        user={user}
        userId={userId}
        screenKey={screenKey}
        includeAccountActions={includeAccountActions}
      />
    ),
    container,
    screenKey,
    fixedHeight,
  });
};

// Export the UserActionsSheet to call as UserActionsSheet.show(...)
export const UserActionsSheet = {
  show,
};
